
<template>
  <div class="caidao-app">
    <component :is="$store.state.device"></component>
  </div>
</template>

<script>
import m from './device/m.vue'
import pc from './device/pc.vue'

export default {
  name: 'caidao-app',

  components: {
    pc,
    m
  }
}
</script>
